import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useQueryState } from "@msuite/ui/libs/nuqs";
import { useTranslation } from "@msuite/ui/localization";
import { Fragment } from "react";
import { AddRoleModal } from "@/modals/organizations/add-role-modal";

/**
 * The create control above the role list. The whole roles tab is already gated on owner-or-admin,
 * so `POST /roles` will not refuse the caller who sees this; the modal invalidates the role list
 * itself on success, so no refetch has to be threaded in.
 */
export function OrganizationSettingsRolesMenu() {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const disclosure = useDisclosure();

	/** State */
	// The same URL parameters the surface reads: the selection, and the detail panel's tab —
	// nuqs shares them by key. The tab index outlives a selection change, so without the reset
	// a reader coming from another role's members tab would meet the new role on that tab.
	const [, setSelectedRoleId] = useQueryState("role");
	const [, setRoleTab] = useQueryState("role-tabs");

	/** Render */
	return (
		<Fragment>
			<Button
				size="xs"
				variant="primary"
				icon={<Icon name="Plus" />}
				onClick={disclosure.onOpen}
				data-cy="create-role-button"
			>
				{t("roles.create_role")}
			</Button>
			{disclosure.isOpen && (
				<AddRoleModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					// The created role opens selected, on its permission tab: creating a role is the
					// first half of granting it something, and the grid is where the second half
					// happens.
					onComplete={(role) => {
						setSelectedRoleId(role.id);
						setRoleTab("0");
					}}
				/>
			)}
		</Fragment>
	);
}
